import BaseModel from './BaseModel'
import {currentDate, currentConseillerId} from '@/helpers'

export default class ProspectFastModel extends BaseModel {
  constructor(data: any, relation: any) {
    const fields = {
      ID_CONSEILLER: currentConseillerId(),
      NOM: '',
      PRENOM: '',
      CODE_REF_CIVILITE: null,
      CODE_REF_DEPARTEMENT: null,
      TELEPHONE1: '',
      EMAIL: '',
      ADRESSE: '',
      NOMBRE_LOTS_PRINCIPAUX: '',
      PERIODE_PROCHAINE_ASSEMBLEE: '',
      COMPTE_RENDU: '',
      DESCRIPTION_ORIGINE: '',
      ASCENSEUR: null,
      CHAUFFAGE: null,
      EMPLOYES: null
    }
    super(data, relation, fields)
  }
}
